import React from 'react';

import { reelsUrl } from '@/config/urls';
import { useGetReelFeedQuery } from '@/graphql';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import constants from '@/theme/exportedVariables.module.scss';
import { useMediaQuery } from '@material-ui/core';
import { useNavigate } from 'react-router';

import dashboardStyles from '../../Dashboard.module.scss';
import Player from './components/Player';
import styles from './ReelThumbnailCard.module.scss';

const ReelThumbnailCard: React.FC<{}> = () => {
	const isTablet = useMediaQuery(`(min-width: ${constants.sizeTablet}`);

	const fireNavigateReelsEvent = useAnalyticsEvent(
		'Dashboard_Navigate_Reels',
	);
	const navigate = useNavigate();

	const {
		data: reelsQuery,
		isLoading: reelsLoading,
		error: reelsError,
	} = useGetReelFeedQuery({}, { refetchOnWindowFocus: false });

	if (reelsError) {
		throw reelsError;
	}
	const reel = reelsQuery?.getReelFeed[0];

	if (!reel) {
		return null;
	}

	return (
		<div className={styles['root']}>
			<div className={dashboardStyles['title']}>Explore reels</div>
			<div
				className={styles['reels']}
				style={{
					backgroundColor:
						reel?.video?.videoCollection?.hex || '#579f9e',
				}}
				onClick={() => {
					navigate(reelsUrl);
					fireNavigateReelsEvent();
				}}
			>
				<Player
					key={`reel-thumbnail`}
					className={styles['reel']}
					dimensionsClassName={styles['dimensions']}
					posterClassName={styles['poster']}
					posterUrl={reel?.posterUrl}
					url={reel?.url}
					noOverlayItems
				/>
				<div className={styles['right-col']}>
					<div className={styles.top}>
						<div className={styles.heading}>
							{reel?.video?.name}
						</div>
						{/* <div className={styles.subtitle}>
							From: {reel?.video?.videoCollection?.name}
						</div> */}
					</div>
					<div className={styles.bottom}>
						<div className={styles.avatar}>
							<img
								className={styles.avatarIcon}
								alt=""
								src={reel?.video?.contributor?.imageUrl || ''}
							/>
							<div className={styles.time2}>
								{reel?.video?.contributor?.name}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReelThumbnailCard;
